export default {
  navbar: 10,
  overlay: 20,
  menu: 30,
  cookie: 40,
};
